module.exports = __webpack_public_path__ + "img/applicants-selection-quota.068544f5.svg";